import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Text, useToast } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import StackedButtonGroup from '../../../../../components/Modal/ModalButtonGroups/StackedButtonGroup';
import {
  deleteEmailTemplate,
  selectCurrentDepartment
} from '../../../../../redux/modules/emails';
import { hideModal } from '../../../../../redux/modules/modal';

const ConfirmDeleteEmailTemplate = ({
  template,
  type,
  companyId
}) => {
  const selectedDepartment = useSelector(selectCurrentDepartment);

  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(hideModal());

    dispatch(deleteEmailTemplate(template, type, selectedDepartment));
  };

  const handleCancel = () => {
    dispatch(hideModal());
  };

  return (
    <Box>
      <Text textAlign="center">{`Are you sure you want to delete ${template.templateName}?`}</Text>

      <Box mb={4} mt={8}>
        <StackedButtonGroup
          dataAnalyticsId="deleteEmailTemplate"
          label="Delete"
          secondaryClick={handleCancel}
          variant="gradientError"
          onClick={handleDelete}
        />
      </Box>
    </Box>
  );
};

ConfirmDeleteEmailTemplate.propTypes = {
  template: PropTypes.shape({
    templateId: PropTypes.number,
    templateName: PropTypes.string,
    templateType: PropTypes.oneOf(['main_content', 'signature'])
  }),
  type: PropTypes.oneOf(['company', 'department']).isRequired,
  companyId: PropTypes.number.isRequired
};

export default ConfirmDeleteEmailTemplate;
